import { API_BASE_URL } from "../constants/api";
import { formatCurrency, formatDate } from "./formatters";

// Configuration des couleurs professionnelles (tons de gris)
export const COLORS = {
  primary: '#2c3e50',    // Bleu-gris foncé
  secondary: '#7f8c8d',   // Gris
  accent: '#3498db',      // Bleu clair (pour touches)
  success: '#27ae60',     // Vert
  warning: '#f39c12',     // Orange
  danger: '#e74c3c',      // Rouge
  light: '#ecf0f1',       // Gris très clair
  dark: '#2c3e50',        // Presque noir
  white: '#ffffff',
  black: '#000000'
};

// Valeurs par défaut
const DEFAULT_SOCIETE = {
  nom: "SAWD",
  adresse: "Libreville, Gabon",
  telephone: "+241 00 00 00 00",
  email: "contact@sawd.com",
  site_web: "www.sawd.com",
  rc: "RC123456",
  nif: "NIF123456",
  patente: "PAT123456"
};

// Fonction pour obtenir les informations de la société (synchrone)
export const getSocieteInfos = () => {
  try {
    const societe = localStorage.getItem("societe");
    if (societe) {
      const parsed = JSON.parse(societe);
      // S'assurer que toutes les clés sont présentes
      return { ...DEFAULT_SOCIETE, ...parsed };
    }
  } catch (error) {
    console.error("Erreur chargement société", error);
  }
  
  // Valeurs par défaut
  return DEFAULT_SOCIETE;
};

// Fonction pour récupérer les infos société depuis l'API
export const fetchSocieteInfos = async () => {
  console.log("🔵 1. Début fetchSocieteInfos");
  
  try {
    const token = localStorage.getItem("token");
    console.log("🔵 2. Token récupéré:", token ? "Oui" : "Non");
    
    if (!token) {
      console.warn("⚠️ Token non trouvé, utilisation des valeurs par défaut");
      return getSocieteInfos();
    }

    console.log("🔵 3. Appel API vers:", `${API_BASE_URL}/parametres.php?action=societe`);
    
    const response = await fetch(`${API_BASE_URL}/parametres.php?action=societe`, {
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    console.log("🔵 4. Statut réponse:", response.status);
    
    if (response.ok) {
      const result = await response.json();
      console.log("🔵 5. Données reçues:", result);
      
      if (result && result.data) {
        // Sauvegarder en cache dans localStorage
        localStorage.setItem("societe", JSON.stringify(result.data));
        console.log("🔵 6. Données sauvegardées dans localStorage");
        return result.data;
      }
    } else {
      console.log("🔵 5. Réponse non OK, status:", response.status);
    }
    
    console.log("🔵 6. Fallback vers localStorage");
    return getSocieteInfos();
  } catch (err) {
    console.error("🔴 Erreur dans fetchSocieteInfos:", err);
    return getSocieteInfos();
  }
};

// Fonction pour initialiser les infos société au démarrage
export const initSocieteInfos = async () => {
  console.log("🚀 Initialisation des informations société...");
  const infos = await fetchSocieteInfos();
  console.log("✅ Informations société initialisées:", infos);
  return infos;
};

// Fonction pour mettre à jour les informations société
export const updateSocieteInfos = async (societeData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_BASE_URL}/parametres.php?action=societe`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(societeData)
    });

    if (response.ok) {
      const result = await response.json();
      if (result.data) {
        // Mettre à jour le cache
        localStorage.setItem("societe", JSON.stringify(result.data));
        return result.data;
      }
    }
    throw new Error('Erreur lors de la mise à jour');
  } catch (err) {
    console.error("Erreur mise à jour société", err);
    throw err;
  }
};

// Styles communs pour les documents
export const getDocumentStyles = () => ({
  header: {
    fontSize: 24,
    bold: true,
    color: COLORS.primary,
    margin: [0, 0, 0, 20],
    alignment: 'center'
  },
  subHeader: {
    fontSize: 16,
    bold: true,
    color: COLORS.secondary,
    margin: [0, 10, 0, 10]
  },
  normal: {
    fontSize: 10,
    color: COLORS.dark
  },
  tableHeader: {
    fontSize: 11,
    bold: true,
    fillColor: COLORS.light,
    color: COLORS.primary,
    alignment: 'center'
  },
  tableCell: {
    fontSize: 10,
    margin: [5, 5, 5, 5]
  },
  footer: {
    fontSize: 8,
    color: COLORS.secondary,
    alignment: 'center',
    margin: [0, 20, 0, 0]
  },
  infoBox: {
    margin: [0, 10, 0, 10],
    padding: [10, 10, 10, 10],
    border: true,
    borderColor: COLORS.light
  }
});